var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppointments = function SvgAppointments(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96 0.56c-0.4 0.384-0.4 0.416-0.4 3.28s0 2.896 0.4 3.28c0.48 0.48 0.864 0.496 1.424 0.064l0.416-0.32v-3.008c0-2.928-0.016-3.008-0.368-3.344-0.48-0.464-0.992-0.448-1.472 0.048z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 0.48c-0.304 0.304-0.32 0.528-0.32 3.36s0.016 3.056 0.32 3.36c0.176 0.176 0.496 0.32 0.72 0.32s0.544-0.144 0.72-0.32c0.304-0.304 0.32-0.528 0.32-3.36s-0.016-3.056-0.32-3.36c-0.176-0.176-0.496-0.32-0.72-0.32s-0.544 0.144-0.72 0.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.712 0.528c-0.336 0.352-0.352 0.512-0.352 3.344v2.992l0.416 0.32c0.56 0.432 0.944 0.416 1.424-0.064 0.4-0.384 0.4-0.416 0.4-3.28s0-2.896-0.4-3.28c-0.48-0.496-1.040-0.512-1.488-0.032z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24 3.168c-0.304 0.144-0.72 0.512-0.912 0.816l-0.368 0.544 0.032 13.008 0.048 12.992 0.4 0.432c0.864 0.928 0.144 0.88 14.64 0.88s13.776 0.048 14.64-0.88l0.4-0.432 0.048-12.992 0.032-13.008-0.368-0.544c-0.512-0.768-1.264-1.104-2.464-1.104h-1.008v2.224l1.68 0.096 0.048 2.192 0.048 2.208h-26.112l0.048-2.208 0.048-2.192 1.68-0.096v-2.224h-0.992c-0.64 0-1.216 0.096-1.568 0.288zM19.36 17.36v1.36h-13.12v-2.72h13.12v1.36zM25.92 23.92v1.36h-19.68v-2.72h19.68v1.36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.72 4v1.12h2.4v-2.24h-2.4v1.12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.040 4v1.12h2.4v-2.24h-2.4v1.12z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppointments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appointments.64e3bff5.svg";
export { ForwardRef as ReactComponent };